import { TreeItemExtended } from "../utils/buildTree";
import { syncGoogle } from "./syncGoogle";
import { GoogleTreeItem } from "./types";

export const getDriveTree = (): TreeItemExtended<GoogleTreeItem>[] => {
  const tree = localStorage.getItem("driveTree");
  if (!tree) return [];
  return JSON.parse(tree);
};
